import { Component } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

@Component({
  selector: 'chicken-test',
  templateUrl: './chicken-test.component.html',
  styleUrls: ['./chicken-test.component.scss']
})
export class ChickenTest {
  public action: string;
  public positive: string;
  public negative: string;
  public noHeader: boolean;

  constructor(public dialogRef: MatDialogRef<ChickenTest>) {}

  capitalizeFirst(str: string) {
    let char = str.charAt(0);
    return char.toUpperCase() + str.substring(1);
  }

  setAction() {
    return 'Are you sure you want to ' + this.action + '?';
  }

  // Added these close functions because there was a silent error running in the console 'ref is null'
  positiveActionClose() {
    this.dialogRef.close(true);
  }

  cancelClose() {
    this.dialogRef.close();
  }
}
